import React from 'react';
import cs from 'classnames';
import pathfinder from '@fiverr-private/pathfinder';
import { I18n } from '@fiverr-private/i18n-react';
import { PAGE_NAME } from '../../../../monitoring';
import { AddEmptyBlock } from '../../../common/AddEmptyBlock';

import styles from './AddPortfolioBlock.module.scss';

interface AddPortfolioBlockProps {
    username: string;
}

const T_PREFIX = 'freelancer_page.portfolio.empty';

// README: "origin" - https://fiverr.slack.com/archives/C2EJFGDR9/p1664449285765759?thread_ts=1664448689.342409&cid=C2EJFGDR9
// Code: https://sourcegraph.fiverrdev.com/github.com/fiverr/5rr_v2/-/blob/app/lib/shared/portfolio/projects_list/ProjectsList.js?L457
const getNewPortfolioUrl = (username: string) =>
    pathfinder(
        'new_user_portfolio',
        { user_id: username },
        { query: { source: PAGE_NAME, origin: 'freelancer_page' } }
    );

const mpEventsConfig = {
    type: 'freelancer page View portfolio empty state',
    clickType: 'freelancer page clicked add portfolio',
};

export const AddPortfolioBlock: React.FC<AddPortfolioBlockProps> = ({ username }) => (
    <AddEmptyBlock
        className={styles.emptyPortfolio}
        contentWrapperClassName={cs(styles.contentWrapper, 'm-20')}
        leftContent={<div className={styles.image} />}
        descriptionTitle={<I18n k={`${T_PREFIX}.title`} />}
        description={<I18n k={`${T_PREFIX}.description`} />}
        buttonText={<I18n k={`${T_PREFIX}.add_button`} />}
        buttonHref={getNewPortfolioUrl(username)}
        mpEvents={mpEventsConfig}
        isPrivate
    />
);
